import { CustomizeCheckoutData } from '@/@types/Checkouts/edit-checkout'
import { IBanner } from '@/@types/Checkouts/list-checkouts'

export function bannerFieldsFromCheckout(
  banners: IBanner[] | null | undefined,
): Partial<CustomizeCheckoutData> {
  return (banners ?? []).reduce<Partial<CustomizeCheckoutData>>((acc, banner) => {
    const {
      desktop_position,
      mobile_position,
      is_desktop_visible,
      is_mobile_visible,
      file,
    } = banner

    if (desktop_position === 'top') {
      acc.banner_desktop_top_image = file?.url ?? null
      acc.banner_desktop_top_is_visible = is_desktop_visible ? '1' : '0'
    } else if (desktop_position === 'bottom') {
      acc.banner_desktop_bottom_image = file?.url ?? null
      acc.banner_desktop_bottom_is_visible = is_desktop_visible ? '1' : '0'
    } else if (desktop_position === 'side') {
      acc.banner_desktop_side_image = file?.url ?? null
      acc.banner_desktop_side_is_visible = is_desktop_visible ? '1' : '0'
    }

    if (mobile_position === 'top') {
      acc.banner_mobile_top_image = file?.url ?? null
      acc.banner_mobile_top_is_visible = is_mobile_visible ? '1' : '0'
    } else if (mobile_position === 'bottom') {
      acc.banner_mobile_bottom_image = file?.url ?? null
      acc.banner_mobile_bottom_is_visible = is_mobile_visible ? '1' : '0'
    }

    return acc
  }, {})
}
